import axios from "axios";

const url = process.env.VUE_APP_BASE_URL_PUBLIC_BACKEND

let service_public = axios.create({
    baseURL: url,
});

export default service_public;